import React, { useState, useEffect, useContext } from "react";
import Navmenu from "../components/Navmenu";
import Appbar from "../components/Appbar";
import "../style/Glimpses.scss";
import { Container, Row, Col } from "bootstrap-4-react";
import Footer from "../components/Footer";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import { Bookmark, BookmarkBorder } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import { apiURL, getID } from "../utils";
import SanitizedHTML from "react-sanitized-html";
import axios from "axios";
import Moment from "moment";
import Meta from "../meta/Meta";
import ShareDialog from "../components/ShareDialog";
import ShareNews from "./ShareNews";
import OtherGr from "./OtherGr";
import TrainingDefaultImageLoader from "../training/TrainingDefaultImage";
import { PWAContext } from "../utils/PwaAppContext";
import NoDataFound from "../common/NoDataFound";

const styles = () => ({
  root: {
    maxWidth: "100%",
  },
});

const NewsSingle = (props) => {
  const [newsData, setNewsData] = useState({});
  const [isBookmark, setIsBookmark] = useState(false);
  const [id, setId] = useState("");
  const [isDataAvailable, setIsDataAvailable] = useState(true);
  const [showShareDialog, setShowShareDialog] = useState(false);
  const PWA = useContext(PWAContext);
  const [hover, setHover] = useState(false)// Added hover effect for button

  const blogListData = () => {
    const headers = { "Content-type": "application/json" };
    const { newsId } = props.match.params;

    axios
      .post(apiURL("news/get_all_news"), { id: newsId, user_id: getID() }, { headers })
      .then((response) => {
        const result = response.data;

        if (result.status === true && result.result?.length > 0) {
          const data = result.result[0];
          setNewsData(data);
          setIsBookmark(data.is_bookmark);
          setId(data.fldi_id);
          setIsDataAvailable(true);
        } else {
          setIsDataAvailable(false);
        }
      })
      .catch(() => {
        setIsDataAvailable(false);
      });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    blogListData();
  }, [props.match.params.newsId]);

  const handleAddBookMark = (id) => {
    axios.post(apiURL("bookmark/addBookmark"), {
      content_id: id,
      content_type: "news",
      user_id: getID(),
    }).then(() => setIsBookmark(true));
  };

  const handleRemoveBookMark = (id) => {
    axios.post(apiURL("bookmark/removeBookmark"), {
      content_id: id,
      content_type: "news",
      user_id: getID(),
    }).then(() => setIsBookmark(false));
  };

  const handleBack = (board) => {
    board === "Maharashtra Board"
      ? props.history.push("/maharashtra-state-board")
      : props.history.push("/central-board");
  };

  const downloadPDF = async () => {
    const response = await fetch(newsData.fldv_pdf_url);
    const blob = await response.blob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "circular.pdf";
    link.click();
    URL.revokeObjectURL(link.href);

    PWA?.isPWA &&
      window.ReactNativeWebView?.postMessage(
        JSON.stringify({
          type: "DOWNLOAD_FILE",
          url: newsData.fldv_pdf_url,
          filename: "circular",
        })
      );
  };

  return (
    <>
      <Meta
        tableName="news"
        objectId={props.match.params.newsId}
        forPage="inner_page"
      />

      <Appbar />
      <div className="sticky-top sign-light">
        <Navmenu />
      </div>

      {/* MAIN CONTENT */}
      {isDataAvailable ? (
        <>
          <section className="grSingle">
            <Container maxWidth="lg">
              <h1>{newsData.fldv_title}</h1>
              <Row>
                <Col lg="6">
                  <SanitizedHTML
                    allowedAttributes={false}
                    allowedTags={false}
                    html={newsData.fldt_description}
                  />
                </Col>
                <Col lg="6">
                  <TrainingDefaultImageLoader
                    imageUrl={newsData.fldv_image_url}
                  />
                </Col>
              </Row>
            </Container>
          </section>

          {/* ACTIONS — spacing added between content and action buttons (NAV-763) */}
          <section className="buttonGRContainer" style={{ marginTop: "24px" }}>
            <Container>
              <div className="actionGrSingle">
                {isBookmark ? (
                  // Bookmark active — orange filled icon with blue border box (matches Articles page style)
                  <IconButton
                    style={{
                      color: "orange",
                      border: "3px solid #064e89",
                    }}
                    onClick={() => handleRemoveBookMark(newsData.fldi_id)}
                  >
                    <Bookmark />
                  </IconButton>
                ) : (
                  // Bookmark inactive — blue outline icon with blue border box (matches Articles page style)
                  <IconButton
                    style={{
                      color: "#064e89",
                      border: "3px solid #064e89",
                    }}
                    onClick={() => handleAddBookMark(newsData.fldi_id)}
                  >
                    <BookmarkBorder />
                  </IconButton>
                )}

                {newsData.fldv_pdf_url && (
                  // button color updated to blue; marginLeft adds space between bookmark icon and download button
                  <Button
                    onClick={downloadPDF}
                    onMouseEnter={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                    style={{
                      backgroundColor: hover ? "#0056b3" : "#007bff",
                      color: "#fff",
                      padding: "6px 12px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      boxShadow: hover ? "0 2px 6px rgba(0,0,0,0.2)" : "none",
                      marginLeft: "12px" // space between bookmark icon and download button
                    }}
                  >
                    Download
                  </Button>
                )}
              </div>

              <div className="grShare">
                <ShareNews
                  shareUrl={window.location.href}
                  title={newsData.fldv_title}
                  date={Moment(newsData.fldv_selected_date).format(
                    "dddd, D MMM, YYYY"
                  )}
                  govt_circulars_id={newsData.fldi_id}
                />
              </div>

              <div className="grBack">
                <Button onClick={() => handleBack(newsData.fldv_boards)}>
                  Back
                </Button>
              </div>
            </Container>
          </section>
        </>
      ) : (
        <NoDataFound message="This circular is no longer available." />
      )}

      {/* ALWAYS VISIBLE */}
      <OtherGr
        id={id}
        boards={newsData?.fldv_boards}
        shareUrl={window.location.href}
        history={props.history}
      />

      <Footer />

      <ShareDialog
        open={showShareDialog}
        onClose={() => setShowShareDialog(false)}
        shareUrl={window.location.href}
        title={newsData.fldv_title}
        date={Moment(newsData.fldv_selected_date).format(
          "dddd, D MMM, YYYY"
        )}
        govt_circulars_id={newsData.fldi_id}
      />
    </>
  );
};

export default withStyles(styles)(NewsSingle);
